// --- API response shapes (snake_case from backend) ---

export interface WaitlistEntryApiResponse {
  id: string;
  list_name: string;
  email: string;
  name: string | null;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export interface WaitlistListApiResponse {
  items: WaitlistEntryApiResponse[];
  total: number;
}

// --- Frontend types (camelCase) ---

export interface WaitlistEntry {
  id: string;
  listName: string;
  email: string;
  name: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export interface WaitlistListResponse {
  items: WaitlistEntry[];
  total: number;
}

export interface WaitlistFilters {
  listName?: string;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: 'created_at' | 'email' | 'list_name';
  sortOrder?: 'asc' | 'desc';
}

// --- Mappers ---

export function mapWaitlistEntryFromApi(api: WaitlistEntryApiResponse): WaitlistEntry {
  return {
    id: api.id,
    listName: api.list_name,
    email: api.email,
    name: api.name,
    userId: api.user_id,
    createdAt: api.created_at,
    updatedAt: api.updated_at,
  };
}

export function mapWaitlistListFromApi(api: WaitlistListApiResponse): WaitlistListResponse {
  return {
    items: api.items.map(mapWaitlistEntryFromApi),
    total: api.total,
  };
}
